import api from "./api";
import {API_APPOINTMENTS_MOBILE_CONNECTIONS, API_MOBILE_CONNECTION, API_MOBILE_CONNECTION_TEST} from "../constants/urls"


export const mobileConnection = {
    getAll: async () => (await api.get(API_MOBILE_CONNECTION)).data,
    getById: async (id) => (await api.get(`${API_MOBILE_CONNECTION}/${id}`)).data,
    create: async (mobileConnection) => (await api.post(API_MOBILE_CONNECTION, mobileConnection)).data,
    update: async (mobileConnection) => (await api.put(`${API_MOBILE_CONNECTION}/${mobileConnection.id}`, mobileConnection)).data,
    delete: async (id) => (await api.delete(`${API_MOBILE_CONNECTION}/${id}`)).data,
    testConnection: async (mobileConnection) => (await api.post(`${API_APPOINTMENTS_MOBILE_CONNECTIONS}/${API_MOBILE_CONNECTION_TEST}`, mobileConnection)).data,
}